import { render, staticRenderFns } from "./EmasculationPollinationComponent.vue?vue&type=template&id=230980b1&scoped=true&"
import script from "./EmasculationPollinationComponent.vue?vue&type=script&lang=js&"
export * from "./EmasculationPollinationComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmasculationPollinationComponent.vue?vue&type=style&index=0&id=230980b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230980b1",
  null
  
)

export default component.exports